import { Box } from '@gemini/core';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { NAME_SPACE } from '@mfe-presentation/hooks/useLoadTranslations';

const CONFIDENCE_RATING = [
    'lowAccuracy',
    'mediocreAccuracy',
    'mediumAccuracy',
    'goodAccuracy',
    'highAccuracy',
];

const ReliabilityScore = ({ rating }: { rating: number }) => {
    const { t } = useTranslation(NAME_SPACE);
    const shouldPelletBeFilled = (index: number) => index < rating;

    return (
        <Box justifyContent="start" alignItems="center" display="flex">
            {Array.from(CONFIDENCE_RATING).map((rate, index) => {
                return (
                    <Box
                        key={'reliability-score-' + index}
                        testId={shouldPelletBeFilled(index) ? 'filled-pellet' : 'outlined-pellet'}
                        borderRadius="radius.rounded"
                        width="6px"
                        height="6px"
                        margin="2px"
                        borderWidth={
                            shouldPelletBeFilled(index) ? 'borderWidth.none' : 'borderWidth.1'
                        }
                        borderStyle="solid"
                        borderColor={
                            shouldPelletBeFilled(index) ? undefined : 'color.border.subdued.default'
                        }
                        backgroundColor={
                            shouldPelletBeFilled(index)
                                ? 'color.surface.brand.secondary.default'
                                : undefined
                        }
                        flexShrink="0"
                    />
                );
            })}
            <Box
                typography="typography.body.14.regular"
                marginLeft="spacing.8"
                color="color.content.default.default"
            >
                {t(`step_results.resultCard.confidence.${CONFIDENCE_RATING[rating - 1]}`)}
            </Box>
        </Box>
    );
};

export default ReliabilityScore;
